import React from 'react'
import { SVGIcon } from '~/utils/types'


export const ArrowRight = (props: SVGIcon) => (
  <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M.438 7c0-.518.361-.945.828-1.003l.109-.007h8.779L6.36 2.186A1.065 1.065 0 016.314.759.89.89 0 017.548.628l.09.08 5.626 5.64c.374.375.396.995.07 1.4l-.081.089-5.625 5.465a.891.891 0 01-1.324-.073 1.069 1.069 0 01-.014-1.335l.082-.09 3.906-3.794H1.374C.857 8.01.437 7.558.438 7z"
      fillRule="evenodd"
    />
  </svg>
)
